module.exports = __webpack_public_path__ + "media/images/players/VINCENT_SCOTT-d7f931d37a997d76ca8a471085f3a84f.png";